import React from 'react';
import { CheckIcon, LockIcon, ShieldCheckIcon, TrophyIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-navy-900 py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-165" data-mp="1j9gz2sqezjay">
      <div className="mx-auto max-w-3xl px-4" data-id="element-166" data-mp="1nbbzlv0itsno">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-167" data-mp="1ncn3dutyv0es">
          Elige tu pack
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border-2 border-silver-300 bg-navy-800 shadow-2xl shadow-black/40" data-id="element-168" data-mp="1x8glruud9o4h">
          <div className="metal-silver h-2 w-full" aria-hidden="true" data-id="element-169" data-mp="227b30scor4mh" />
          <div className="p-6 sm:p-10" data-id="element-170" data-mp="2vh13nb4q3qc">
            <span className="metal-silver inline-flex items-center gap-2 rounded-md px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-navy-950" data-id="element-171" data-mp="2wjohl98to1i">
              <TrophyIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-172" data-mp="1mhq0kagbnggu" /> Oferta principal
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-silver-400/25 pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-173" data-mp="1hp6d8lru16yu">
              <div data-id="element-174" data-mp="1cosbtmkqkv9s">
                <h3 className="text-2xl font-extrabold leading-tight text-white" data-id="element-175" data-mp="17s201bfyslu6">{productShortName}</h3>
                <p className="mt-2 text-sm text-silver-200" data-id="element-176" data-mp="25fafaopdgynq">
                  Los {totalVolumes} tomos + {totalBonuses} bonos estratégicos listos para usar en el aula.
                </p>
              </div>
              <div className="shrink-0 sm:text-right" data-id="element-177" data-mp="1vgtkfgnbbzwe">
                <span className="text-sm text-silver-300" data-id="element-178" data-mp="1vjftxltrkph9">
                  Precio regular: <span className="line-through" data-id="element-179" data-mp="1rezqrsbjbw5q">{priceBefore}</span>
                </span>
                <p className="mt-1 flex items-baseline gap-2 sm:justify-end" data-id="element-180" data-mp="k2z9fe3crinj">
                  <span className="text-sm font-bold uppercase text-silver-300" data-id="element-181" data-mp="g0colx53mxzu">Hoy:</span>
                  <span className="metal-text font-serif text-5xl font-extrabold tracking-tight" data-id="element-182" data-mp="hh8c3k45ufap">{price}</span>
                </p>
                <p className="mt-2 inline-block rounded-md border border-silver-300 bg-navy-950 px-2.5 py-1 text-xs font-extrabold uppercase tracking-[.14em] text-silver-100" data-id="element-183" data-mp="mfjmbvydartg">
                  Más del 50% de descuento
                </p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-184" data-mp="3uwed4d1w4lr6">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-silver-100" data-id="element-185" data-mp="3i8l45t6dobd">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-silver-300" aria-hidden="true" data-id="element-186" data-mp="3kzjhc1x04zgl" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-187" data-mp="3bxa7zfdgzc4s">
              Quiero el Megapack
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-silver-200" data-id="element-188" data-mp="3g1873q2somxu">
              <span className="inline-flex items-center gap-1.5" data-id="element-189" data-mp="2sc9xv0l3mkf4">
                <LockIcon className="h-4 w-4 text-silver-300" aria-hidden="true" data-id="element-190" data-mp="2se380pux7mrv" /> Pago seguro
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-191" data-mp="369f3x0ktbjad">
                <ZapIcon className="h-4 w-4 text-silver-300" aria-hidden="true" data-id="element-192" data-mp="31b576ljfwamn" /> Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-193" data-mp="3g7uritkmsaf4">
                <ShieldCheckIcon className="h-4 w-4 text-silver-300" aria-hidden="true" data-id="element-194" data-mp="3ba31k53jqydk" /> Garantía 7 días
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-silver-300" data-id="element-195" data-mp="3p43sico9bh3d">
              Pagas en USD. Tu plataforma de pago muestra la conversión a tu moneda local automáticamente.
            </p>
          </div>
        </article>
      </div>
    </section>;
}